// @flow
import React from 'react'
import classnames from 'classnames'
import Link from 'next/link'

import { truncate } from '~/core/utils/functions'
import { useBreadcrumbsStyles } from './styles'

export type BreadcrumbsLink = {
  path: string,
  label: string,
  isActive?: boolean,
  isDisabled?: boolean
}

type BreadcrumbsProps = {
  links: BreadcrumbsLink[]
}

const Separator = () => <i className="icon icon-m separator">chevronright</i>

const Breadcrumbs = ({ links, ...props }: BreadcrumbsProps) => {
  const classes = useBreadcrumbsStyles()
  return (
    <h2 className={classes.breadcrumbsWrapper} {...props}>
      {links.map(({ path, label, isActive, isDisabled }, idx) => {
        return [
          <Link key={path} href={path}>
            <a
              className={classnames(classes.breadcrumbsLink, {
                active: isActive === true,
                disabled: isDisabled === true
              })}
            >
              {truncate(label, 70)}
            </a>
          </Link>,
          idx < links.length - 1 && <Separator key={`${path}-separator`} />
        ]
      })}
    </h2>
  )
}

export default Breadcrumbs
